import {Separator} from 'platform/components';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {usePermissions} from '@dms/shared';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function FeatureSelectorSubSection() {
  const [canReadBusinessCase] = usePermissions({permissionKeys: ['businessCaseRead']});

  return (
    <VFKit.SubSection data-testid="features-selector" title={i18n.t('general.labels.allFeatures')}>
      <VFKit.ShowWhen when={canReadBusinessCase}>
        <VFKit.FeatureSelector />
      </VFKit.ShowWhen>

      <Separator spacing={2} />

      <VFKit.ShowWhen whenFeatureEnabled={featureFlags.SALES_FEATURES_ADDITIONAL_INFO}>
        <VFKit.FeaturesByManufacturerTextarea />
      </VFKit.ShowWhen>
    </VFKit.SubSection>
  );
}
